import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { SelectInput } from '../../../../components/form-elements/_index';
import { SelectListItem } from '../../../../models/utilities/selectlist-item';
import { ShipmentType } from '../../../models/enums/shipment-type';
import { RunningTotal } from '../../../models/shared/running-total';
import { CreateBackhaulAction } from './CreateBackhaulAction';
import { CreateCustomerDeliveryWizard } from './CreateCustomerDeliveryWizard';
import { ShipmentStatus } from '../../../models/enums/shipment-status';
import { useStore } from 'react-redux';
import { getCurrentServiceCenter } from '../../../../selectors/userdata-selectors';

interface IProps {
    visible         : boolean;
    onSuccess       : any;
    onClose         : any;
    truckId: number;
    serviceCenterId: string;
    truckVersion    : string;
    truckTotals     : RunningTotal|undefined;
    entityType: ShipmentType;
    shipmentStatus: ShipmentStatus;
}

export const ActionAddActivity = (props: IProps) => {

    const store = useStore();
    const [stopType, setStopType] = React.useState<any>();
    const [allStopTypes] = React.useState<any>(() => {
        
        const atList: Array<SelectListItem<string>> = [];

        atList.push(new SelectListItem({ id: '1', name: 'Customer Delivery' }));

        if (props.entityType === ShipmentType.Truck) {
            atList.push(new SelectListItem({ id: '2', name: 'Backhaul' }));
        }
                
        return atList;
    });

    function isProductionServiceCenter(): boolean {
        return ["IN", "MAIN"].indexOf(props.serviceCenterId) > -1
    }

    const onTypeChange = (e : any) => {
        setStopType(e.target.value);
    };

    const getChildNode = () => {
        if (stopType === '1') {
            return <CreateCustomerDeliveryWizard
                        truckId={ props.truckId }
                        serviceCenterId={props.serviceCenterId}
                        truckVersion={ props.truckVersion }
                        truckTotals={ props.truckTotals }
                        onSuccess={ props.onSuccess } 
                        entityType={ props.entityType }
                        onCancel={ cleanup } />;
        }
        else if (stopType === '2') {
            return <CreateBackhaulAction
                        onSuccess={ props.onSuccess }
                        onCancel={ cleanup }
                        truckId={ props.truckId}
                        entityType={ props.entityType }
                        truckVersion={ props.truckVersion } />;
        }
        else {
            return <div className="no-activity">No Stop Type Selected Yet</div>;
        }
    };

    const cleanup = () => {
        setStopType('');
        props.onClose();
    };

    return <Drawer 
                anchor="right" 
                onClose={ cleanup }
                open={ props.visible }>
                <div className="stop-action-drawer stop-action-add-activity">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>Add Stop to Route</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <p>Select the type of stop you'd like to add to get started:</p>
                            <SelectInput
                                id="activityType"
                                label="Stop Type"
                                onChange={ onTypeChange }
                                options={ allStopTypes }
                                value={ stopType }/>
                        </div>
                    </div>
                    
                    <hr/>

                    { getChildNode() }
                    
                </div>
        </Drawer>;
};
